import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7dd98652"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-form" }
const _hoisted_2 = {
  key: 0,
  class: "item"
}
const _hoisted_3 = {
  key: 1,
  class: "item"
}
const _hoisted_4 = { class: "base-form" }
const _hoisted_5 = {
  key: 0,
  style: {"text-align":"right"}
}
const _hoisted_6 = {
  key: 0,
  style: {"text-align":"right","line-height":"1rem","margin-top":"1rem"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Opportunity = _resolveComponent("Opportunity")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (_ctx.isCreatingViewMode)
                ? (_openBlock(), _createElementBlock("h2", _hoisted_2, " Новая категория сервисных работ "))
                : (_openBlock(), _createElementBlock("h2", _hoisted_3, [
                    _createTextVNode(" Карточка категории "),
                    _createElementVNode("span", null, _toDisplayString(_ctx.serviceCategory?.name), 1)
                  ]))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_form, {
                model: _ctx.ruleForm,
                ref: "jobForm",
                "status-icon": "",
                rules: _ctx.rules
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "Категория",
                    "label-position": "top",
                    prop: "name"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.ruleForm.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ruleForm.name) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "Стоимость нормо-часа (руб.)",
                    "label-position": "top",
                    prop: "costPerHour"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        modelValue: _ctx.ruleForm.costPerHour,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ruleForm.costPerHour) = $event)),
                        min: 0,
                        step: 10
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "Описание",
                    "label-position": "top",
                    prop: "description"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.ruleForm.description,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ruleForm.description) = $event)),
                        maxlength: "255",
                        "show-word-limit": "",
                        type: "textarea"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, { style: {"width":"100%"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 10 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                type: "primary",
                                disabled: _ctx.asyncOperationPending,
                                onClick: _ctx.onFormSubmitClick
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.isCreatingViewMode ? 'Создать' : 'Сохранить'), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled", "onClick"]),
                              _createTextVNode("   "),
                              _createVNode(_component_el_button, { onClick: _ctx.onFormCancelClick }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Отменить ")
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 14 }, {
                            default: _withCtx(() => [
                              (!_ctx.isCreatingViewMode)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    _createVNode(_component_el_button, {
                                      type: "danger",
                                      disabled: !_ctx.isDeletionAllowed || _ctx.asyncOperationPending,
                                      onClick: _ctx.onFormDeleteClick
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Удалить категорию ")
                                      ]),
                                      _: 1
                                    }, 8, ["disabled", "onClick"])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, { style: {"width":"100%"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 10 }, {
                        default: _withCtx(() => [
                          _createTextVNode("   ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 14 }, {
                        default: _withCtx(() => [
                          (!_ctx.isCreatingViewMode && !_ctx.isDeletionAllowed)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _createVNode(_component_el_text, {
                                  type: "info",
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_icon, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Opportunity)
                                      ]),
                                      _: 1
                                    }),
                                    _createTextVNode(" Категорию нельзя удалить - на нее ссылаются сервисные работы (ссылок " + _toDisplayString(_ctx.referencedJobsCount) + ") ", 1)
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}